/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Plh_Confirm_CancelInputs */

const vi_pkl_plh_confirm_cancel = /** @type {(inputs: Pkl_Plh_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy phiếu lấy hàng này?`)
};

/**

* @param {Pkl_Plh_Confirm_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_plh_confirm_cancel = /** @type {((inputs?: Pkl_Plh_Confirm_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Plh_Confirm_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_plh_confirm_cancel(inputs)
});